import React, { useState } from 'react';
import {
  Nav, NavItem, NavLink, TabContent, TabPane 
} from 'reactstrap';
import classnames from 'classnames';
import SocialWallBgUpload from './SocialWallBgUpload';
import SocialWallImages from './SocialWallImages';

const SocialBgTabs = (props) => {
  const [activeTab, setActiveTab] = useState(props.activeTab);

  const [socialWallImage, setSocialWallImg] = useState(props.socialWallImg) //for selected icon
  const [socialWallImgs, setSocialWallImages] = useState([])

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="tabs__wrap">
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => toggle('1')}
          >
            Upload Files
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => toggle('2')}
          >
            Library
          </NavLink>
        </NavItem>
        
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
            <SocialWallBgUpload toggle={toggle} setSocialWallImages={setSocialWallImages} onCancel={props.onCancel} />
        </TabPane>
        <TabPane tabId="2">
          <SocialWallImages 
            setSocialWallImg={setSocialWallImg} 
            onCancel={props.onCancel} 
            onSelectIconOK={props.onSelectIconOK} 
            setSocialWallImages={setSocialWallImages} 
            socialWallImgs={socialWallImgs} 
            socialWallImage={socialWallImage} 
          />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default SocialBgTabs;
